var _path, _path2, _ellipse, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1447 14.9468V9C46.1447 7.34314 44.8015 6 43.1447 6H13C11.3431 6 10 7.34315 10 9V63.8382C10 65.4951 11.3431 66.8382 13 66.8382H28.0723",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6055 19.9491H66.5984C68.2553 19.9491 69.5984 21.2922 69.5984 22.9491V81C69.5984 82.6569 68.2553 84 66.5984 84H34.6055C32.9486 84 31.6055 82.6569 31.6055 81V22.9491C31.6055 21.2922 32.9486 19.9491 34.6055 19.9491Z",
    fill: "#BABFFC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.6017,
    cy: 70.2748,
    rx: 3.59393,
    ry: 3.55838,
    fill: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59.25C69 59.25 80 53.75 80 45.5V35.875L69 31.75L58 35.875V45.5C58 53.75 69 59.25 69 59.25Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59.25C69 59.25 80 53.75 80 45.5V35.875L69 31.75L58 35.875V45.5C58 53.75 69 59.25 69 59.25Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 41L67 48.5L64 45",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyPhone);
export default __webpack_public_path__ + "static/media/VerifyPhone.6387a28da5b186c4dc5403ac2b96058c.svg";
export { ForwardRef as ReactComponent };